import React, { useEffect, useState } from 'react';
import RibbonActions from '../components/RibbonActions';
import {
  getPeriodos, getPeriodo, crearPeriodo, liquidarPeriodo, cerrarPeriodo, reabrirPeriodo, borrarPeriodo, ajustarLiq, enviarNominaDian, enviarNominaPeriodo, getDesprendibleNominaPDF,
  getConceptosNomina, getNovedades, agregarNovedad, eliminarNovedad,
} from '../services/api';

const fmtCOP = n => '$' + Number(n || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const MES_NOM = ['', 'Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

export default function Nomina() {
  const [periodos, setPeriodos] = useState([]);
  const [verPeriodo, setVerPeriodo] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const cargar = async () => {
    setLoading(true);
    try { const { data } = await getPeriodos(); setPeriodos(data); setError(''); }
    catch (err) { setError(err.response?.data?.error || 'Error al cargar'); }
    finally { setLoading(false); }
  };
  useEffect(() => { cargar(); }, []);

  const onCrear = async () => {
    const hoy = new Date();
    const ano = parseInt(prompt('Año del periodo', hoy.getFullYear()));
    const mes = parseInt(prompt('Mes del periodo (1-12)', hoy.getMonth() + 1));
    if (!ano || !mes) return;
    try { await crearPeriodo({ ano, mes }); cargar(); }
    catch (err) { alert(err.response?.data?.error || 'Error'); }
  };

  const onBorrar = async (p) => {
    if (!window.confirm(`¿Eliminar periodo ${MES_NOM[p.mes]} ${p.ano}?`)) return;
    try { await borrarPeriodo(p.id); cargar(); }
    catch (err) { alert(err.response?.data?.error); }
  };

  if (verPeriodo) return <DetallePeriodo id={verPeriodo} onBack={() => { setVerPeriodo(null); cargar(); }} />;

  return (
    <div style={S.container}>
      <div style={S.headerRow}>
        <div>
          <h1 style={S.title}>Liquidación</h1>
          <p style={S.sub}>Liquidación mensual de empleados — devengos, deducciones y aportes patronales · {periodos.length} periodos</p>
        </div>
        <RibbonActions><button onClick={onCrear} style={S.btnPri}>+ Crear periodo</button></RibbonActions>
      </div>

      {error && <div style={S.error}>{error}</div>}

      <table style={S.table}>
        <thead>
          <tr>
            <th style={S.th}>Periodo</th>
            <th style={S.th}>Empleados</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Devengos</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Deducciones</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Neto</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Aportes patronales</th>
            <th style={S.th}>Estado</th>
            <th style={S.th}>Comprobante</th>
            <th style={S.th}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {loading ? <tr><td colSpan={9} style={{ ...S.td, textAlign: 'center', padding: 30 }}>Cargando…</td></tr>
            : periodos.length === 0 ? <tr><td colSpan={9} style={{ ...S.td, textAlign: 'center', padding: 30, color: '#94a3b8' }}>Sin periodos creados</td></tr>
            : periodos.map(p => (
              <tr key={p.id}>
                <td style={S.td}><strong>{MES_NOM[p.mes]}</strong> {p.ano}</td>
                <td style={S.td}>{p.num_empleados}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace' }}>{fmtCOP(p.total_devengos)}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace' }}>{fmtCOP(p.total_deducciones)}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace' }}>{fmtCOP(p.total_neto)}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace' }}>{fmtCOP(p.total_aportes_patronales)}</td>
                <td style={S.td}>
                  <span style={{ ...S.badge, background: p.estado === 'cerrado' ? '#dcfce7' : '#fef3c7', color: p.estado === 'cerrado' ? '#166534' : '#92400e' }}>
                    {p.estado}
                  </span>
                </td>
                <td style={{ ...S.td, fontFamily: 'monospace', fontSize: 12 }}>{p.comprobante_numero || '—'}</td>
                <td style={S.tdAcc}>
                  <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end', alignItems: 'center' }}>
                    <button style={S.btnView} onClick={() => setVerPeriodo(p.id)}>Ver / Liquidar</button>
                    {p.estado === 'borrador' && <button style={{ ...S.iconBtn, borderColor: '#7f1d1d' }} title="Eliminar" onClick={() => onBorrar(p)}>🚫</button>}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

// ──────────────────────────────────────────────────────────────────────────────
function DetallePeriodo({ id, onBack }) {
  const [data, setData] = useState(null);
  const [novLiq, setNovLiq] = useState(null); // liquidación con el modal de novedades abierto
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo]   = useState('');

  const cargar = async () => {
    try { const { data } = await getPeriodo(id); setData(data); setError(''); }
    catch (err) { setError(err.response?.data?.error || 'Error'); }
  };
  useEffect(() => { cargar(); /* eslint-disable-line */ }, [id]);

  const onLiquidar = async () => {
    setWorking(true); setError(''); setInfo('');
    try {
      const { data } = await liquidarPeriodo(id);
      setInfo(`✓ Liquidación recalculada — ${data.empleados} empleados, neto ${fmtCOP(data.total_neto)}`);
      cargar();
    } catch (err) { setError(err.response?.data?.error || 'Error'); }
    finally { setWorking(false); }
  };

  const onCerrar = async () => {
    if (!window.confirm('¿Cerrar este periodo? Genera el comprobante contable y bloquea modificaciones.')) return;
    setWorking(true); setError(''); setInfo('');
    try {
      const { data } = await cerrarPeriodo(id);
      setInfo(`✓ Periodo cerrado — comprobante ${data.comprobante.numero}`);
      cargar();
    } catch (err) { setError(err.response?.data?.error || 'Error'); }
    finally { setWorking(false); }
  };

  const onAjustarDias = async (liq) => {
    const nuevo = parseInt(prompt(`Días trabajados (1-30)`, liq.dias_trabajados));
    if (!nuevo || nuevo < 1 || nuevo > 30) return;
    try { await ajustarLiq(liq.id, { dias_trabajados: nuevo }); cargar(); }
    catch (err) { alert(err.response?.data?.error); }
  };

  const onReabrir = async () => {
    if (!window.confirm('¿Reabrir el período? Vuelve a borrador y anula el comprobante contable para que puedas corregir salarios y re-liquidar. (No se puede si alguna nómina ya fue aceptada por la DIAN.)')) return;
    setWorking(true); setError(''); setInfo('');
    try {
      const { data } = await reabrirPeriodo(id);
      setInfo('✓ ' + (data.mensaje || 'Período reabierto'));
      cargar();
    } catch (err) { setError(err.response?.data?.error || 'Error al reabrir'); }
    finally { setWorking(false); }
  };

  const [enviandoTodo, setEnviandoTodo] = useState(false);
  const onEnviarTodo = async () => {
    const pend = data.liquidaciones.filter(l => l.ne_estado !== 'aceptada').length;
    if (!window.confirm(`Transmitir a la DIAN la nómina electrónica de ${pend} empleado(s)?`)) return;
    setEnviandoTodo(true); setError(''); setInfo('');
    try {
      const { data: r } = await enviarNominaPeriodo(id);
      const fallidas = r.resultados.filter(x => x.estado !== 'aceptada');
      if (fallidas.length === 0) setInfo(`✅ ${r.aceptadas} nómina(s) ACEPTADAS por la DIAN`);
      else setError(`${r.aceptadas}/${r.total} aceptadas. Con problema: ` + fallidas.map(f => `${f.empleado} (${f.error || f.estado})`).join(' · '));
      cargar();
    } catch (err) { setError('❌ ' + (err.response?.data?.error || 'Error al transmitir')); }
    finally { setEnviandoTodo(false); }
  };

  const [enviandoNe, setEnviandoNe] = useState(null);
  const onEnviarDian = async (liq) => {
    if (!window.confirm(`Transmitir la nómina electrónica de ${liq.apellidos}, ${liq.nombres} a la DIAN?`)) return;
    setEnviandoNe(liq.id); setError(''); setInfo('');
    try {
      const { data } = await enviarNominaDian(liq.id);
      setInfo(`✅ Nómina ${data.numero} ACEPTADA por la DIAN — CUNE ${data.cune.slice(0, 20)}…`);
      cargar();
    } catch (err) { setError('❌ ' + (err.response?.data?.error || 'Error al transmitir la nómina')); }
    finally { setEnviandoNe(null); }
  };

  const onDesprendible = async (liq) => {
    try {
      const { data: blob } = await getDesprendibleNominaPDF(liq.id);
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) { setError('No se pudo generar el desprendible'); }
  };

  if (!data) return <div style={S.container}>Cargando…</div>;

  const cerrado = data.estado === 'cerrado';

  return (
    <div style={S.container}>
      <button onClick={onBack} style={{ ...S.btnSec, padding: '4px 10px', marginBottom: 8 }}>← Volver</button>
      <div style={S.headerRow}>
        <div>
          <h1 style={S.title}>{MES_NOM[data.mes]} {data.ano}</h1>
          <p style={S.sub}>{data.fecha_inicio} → {data.fecha_fin} · {data.liquidaciones.length} empleados</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {!cerrado && <button onClick={onLiquidar} disabled={working} style={S.btnPri}>Liquidar / Recalcular</button>}
          {!cerrado && data.liquidaciones.length > 0 && (
            <button onClick={onCerrar} disabled={working} style={{ ...S.btnPri, background: '#10b981' }}>Cerrar periodo</button>
          )}
          {cerrado && data.liquidaciones.some(l => l.ne_estado !== 'aceptada') && (
            <button onClick={onEnviarTodo} disabled={enviandoTodo} style={{ ...S.btnPri, background: '#4f46e5' }}>
              {enviandoTodo ? 'Enviando…' : '📤 Enviar toda la nómina'}
            </button>
          )}
          {cerrado && !data.liquidaciones.some(l => l.ne_estado === 'aceptada') && (
            <button onClick={onReabrir} disabled={working} style={{ ...S.btnSec, borderColor: '#f59e0b', color: '#f59e0b' }}>↩ Reabrir</button>
          )}
        </div>
      </div>

      {error && <div style={S.error}>{error}</div>}
      {info  && <div style={S.info}>{info}</div>}

      <div style={S.summary}>
        <Stat label="Devengos"      value={data.total_devengos} />
        <Stat label="Deducciones"   value={data.total_deducciones} />
        <Stat label="Neto a pagar"  value={data.total_neto} positivo />
        <Stat label="Aportes patron."value={data.total_aportes_patronales} />
      </div>

      <table style={S.table}>
        <thead>
          <tr>
            <th style={S.th}>Empleado</th>
            <th style={S.th}>Días</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Salario</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Aux. transp.</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Devengos</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Salud 4%</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Pensión 4%</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Neto</th>
            {!cerrado && <th style={S.th}></th>}
            {cerrado && <th style={S.th}>Nómina Electrónica</th>}
          </tr>
        </thead>
        <tbody>
          {data.liquidaciones.length === 0
            ? <tr><td colSpan={9} style={{ ...S.td, textAlign: 'center', padding: 30, color: '#94a3b8' }}>
                Sin liquidaciones. Pulsa "Liquidar / Recalcular" para generar.
              </td></tr>
            : data.liquidaciones.map(l => (
              <tr key={l.id}>
                <td style={S.td}>
                  <div style={{ fontWeight: 600 }}>{l.apellidos}, {l.nombres}</div>
                  <div style={{ fontSize: 11, color: '#64748b' }}>{l.numero_documento} · {l.cargo || '—'} · ARL {l.arl_riesgo}</div>
                </td>
                <td style={{ ...S.td, fontFamily: 'monospace' }}>{l.dias_trabajados}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace' }}>{fmtCOP(l.salario_proporcional)}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace' }}>{fmtCOP(l.auxilio_transporte)}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace', fontWeight: 600 }}>{fmtCOP(l.total_devengos)}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace', color: '#b91c1c' }}>{fmtCOP(l.salud_empleado)}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace', color: '#b91c1c' }}>{fmtCOP(l.pension_empleado)}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace', fontWeight: 700, color: '#15803d' }}>{fmtCOP(l.neto_a_pagar)}</td>
                {!cerrado && (
                  <td style={S.tdAcc}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => onAjustarDias(l)} style={S.btnEdit}>Días</button>
                      <button onClick={() => setNovLiq(l)} style={{ ...S.btnEdit, borderColor: '#6366f1', color: '#a5b4fc' }}>+ Novedades</button>
                      <button onClick={() => onDesprendible(l)} style={{ ...S.btnEdit, borderColor: '#0ea5e9', color: '#7dd3fc' }}>Desprendible</button>
                    </div>
                  </td>
                )}
                {cerrado && (
                  <td style={S.td}>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                      {l.ne_estado === 'aceptada'
                        ? <span style={{ color: '#15803d', fontSize: 12, fontWeight: 600 }} title={l.cune}>✅ {l.ne_numero}</span>
                        : <button onClick={() => onEnviarDian(l)} disabled={enviandoNe === l.id} style={S.btnPri}>
                            {enviandoNe === l.id ? 'Enviando…' : '📤 Enviar a DIAN'}
                          </button>}
                      <button onClick={() => onDesprendible(l)} style={{ ...S.btnEdit, borderColor: '#0ea5e9', color: '#7dd3fc' }}>Desprendible</button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </table>

      {novLiq && <NovedadesModal liq={novLiq} onClose={() => { setNovLiq(null); cargar(); }} />}
    </div>
  );
}

function NovedadesModal({ liq, onClose }) {
  const [conceptos, setConceptos] = useState([]);
  const [lista, setLista] = useState([]);
  const [form, setForm] = useState({ tipo: '', cantidad: '', porcentaje: '', valor: '', fecha_inicio: '', fecha_fin: '', descripcion: '' });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const cargar = () => getNovedades(liq.id).then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { getConceptosNomina().then(r => setConceptos(r.data)).catch(() => {}); cargar(); /* eslint-disable-line */ }, [liq.id]);

  const cat = conceptos.find(c => c.tipo === form.tipo);
  const agregar = async () => {
    if (!form.tipo) return setErr('Elegí un concepto');
    const c = conceptos.find(x => x.tipo === form.tipo);
    setSaving(true); setErr('');
    try {
      await agregarNovedad(liq.id, { categoria: c.categoria, tipo: c.tipo, cantidad: form.cantidad || null,
        porcentaje: form.porcentaje || null, valor: form.valor || null, fecha_inicio: form.fecha_inicio || null,
        fecha_fin: form.fecha_fin || null, descripcion: form.descripcion || null });
      setForm({ tipo: '', cantidad: '', porcentaje: '', valor: '', fecha_inicio: '', fecha_fin: '', descripcion: '' });
      cargar();
    } catch (e) { setErr(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };
  const borrar = async (id) => { await eliminarNovedad(id).catch(() => {}); cargar(); };

  const totDev = lista.filter(n => n.categoria === 'devengado').reduce((s, n) => s + Number(n.valor) + Number(n.valor_ns), 0);
  const totDed = lista.filter(n => n.categoria === 'deduccion').reduce((s, n) => s + Number(n.valor), 0);

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={{ ...S.modal, maxWidth: 640 }} onClick={e => e.stopPropagation()}>
        <div style={S.modalHeader}>
          <h2 style={{ ...S.title, fontSize: 18 }}>Novedades — {liq.apellidos}, {liq.nombres}</h2>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto auto', gap: 8, alignItems: 'end', marginBottom: 12 }}>
          <div>
            <label style={S.lbl}>Concepto</label>
            <select style={S.inp} value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })}>
              <option value="">Elegir concepto…</option>
              <optgroup label="Devengados">{conceptos.filter(c => c.categoria === 'devengado').map(c => <option key={c.tipo} value={c.tipo}>{c.label}</option>)}</optgroup>
              <optgroup label="Deducciones">{conceptos.filter(c => c.categoria === 'deduccion').map(c => <option key={c.tipo} value={c.tipo}>{c.label}</option>)}</optgroup>
            </select>
          </div>
          {cat?.entrada === 'horas' && <div><label style={S.lbl}>Horas</label><input type="number" style={{ ...S.inp, width: 90 }} value={form.cantidad} onChange={e => setForm({ ...form, cantidad: e.target.value })} /></div>}
          {cat?.entrada === 'dias' && <div><label style={S.lbl}>Días</label><input type="number" style={{ ...S.inp, width: 90 }} value={form.cantidad} onChange={e => setForm({ ...form, cantidad: e.target.value })} /></div>}
          {cat?.entrada === 'diasBase' && <div><label style={S.lbl}>Días causados</label><input type="number" style={{ ...S.inp, width: 110 }} value={form.cantidad} onChange={e => setForm({ ...form, cantidad: e.target.value })} /></div>}
          {cat?.entrada === 'porcentaje' && <div><label style={S.lbl}>%</label><input type="number" step="0.01" style={{ ...S.inp, width: 80 }} value={form.porcentaje} onChange={e => setForm({ ...form, porcentaje: e.target.value })} /></div>}
          {cat?.entrada === 'valor' && <div><label style={S.lbl}>Valor $</label><input type="number" style={{ ...S.inp, width: 130 }} value={form.valor} onChange={e => setForm({ ...form, valor: e.target.value })} /></div>}
          <button onClick={agregar} disabled={saving} style={S.btnPri}>{saving ? '…' : '+ Agregar'}</button>
        </div>
        {cat?.entrada === 'dias' && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
            <div><label style={S.lbl}>Desde</label><input type="date" style={S.inp} value={form.fecha_inicio} onChange={e => setForm({ ...form, fecha_inicio: e.target.value })} /></div>
            <div><label style={S.lbl}>Hasta</label><input type="date" style={S.inp} value={form.fecha_fin} onChange={e => setForm({ ...form, fecha_fin: e.target.value })} /></div>
          </div>
        )}
        {err && <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 8 }}>{err}</div>}

        <table style={S.table}>
          <thead><tr><th style={S.th}>Concepto</th><th style={S.th}>Detalle</th><th style={{ ...S.th, textAlign: 'right' }}>Valor</th><th style={S.th}></th></tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={4} style={{ ...S.td, textAlign: 'center', color: '#94a3b8', padding: 16 }}>Sin novedades</td></tr>}
            {lista.map(n => {
              const c = conceptos.find(x => x.tipo === n.tipo);
              return (
                <tr key={n.id}>
                  <td style={S.td}><span style={{ color: n.categoria === 'devengado' ? '#15803d' : '#b91c1c' }}>{n.categoria === 'devengado' ? '➕' : '➖'}</span> {c?.label || n.tipo}</td>
                  <td style={{ ...S.td, fontSize: 12, color: '#64748b' }}>{n.cantidad ? `${n.cantidad} ${c?.entrada === 'horas' ? 'h' : 'días'}` : n.porcentaje ? `${n.porcentaje}%` : n.descripcion || '—'}</td>
                  <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace' }}>{fmtCOP(Number(n.valor) + Number(n.valor_ns))}</td>
                  <td style={S.td}><button onClick={() => borrar(n.id)} style={{ ...S.btnEdit, borderColor: '#7f1d1d', color: '#fca5a5' }}>✕</button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 20, marginTop: 10, fontSize: 13 }}>
          <span style={{ color: '#15803d' }}>Devengados +{fmtCOP(totDev)}</span>
          <span style={{ color: '#b91c1c' }}>Deducciones −{fmtCOP(totDed)}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
          <button onClick={onClose} style={S.btnPri}>Listo</button>
        </div>
      </div>
    </div>
  );
}

const Stat = ({ label, value, positivo }) => (
  <div style={S.stat}>
    <div style={{ fontSize: 11, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</div>
    <div style={{ fontSize: 18, fontWeight: 700, fontFamily: 'monospace', color: positivo ? '#15803d' : '#0f172a', marginTop: 4 }}>{fmtCOP(value)}</div>
  </div>
);

const S = {
  overlay:     { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal:       { background: '#fff', borderRadius: 12, padding: 18, width: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  closeBtn:    { background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#64748b' },
  lbl:         { display: 'block', fontSize: 11, color: '#64748b', marginBottom: 3 },
  inp:         { padding: '7px 9px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 13, width: '100%', boxSizing: 'border-box' },
  container: { padding: 24, maxWidth: 1400, margin: '0 auto' },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 14, flexWrap: 'wrap', gap: 10 },
  title:     { fontSize: 24, fontWeight: 700, color: '#0f172a', margin: 0 },
  sub:       { color: '#64748b', margin: '4px 0 0', fontSize: 13 },
  error:     { background: '#fee2e2', border: '1px solid #fca5a5', color: '#991b1b', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 13 },
  info:      { background: '#dcfce7', border: '1px solid #86efac', color: '#166534', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 13 },
  summary:   { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10, marginBottom: 14 },
  stat:      { background: '#fff', borderRadius: 8, padding: 14, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' },
  table:     { width: '100%', borderCollapse: 'collapse', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', borderRadius: 8, overflow: 'hidden' },
  th:        { background: '#f1f5f9', padding: '10px 12px', textAlign: 'left', fontSize: 12, color: '#475569', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3, borderBottom: '1px solid #e2e8f0' },
  td:        { padding: '4px 12px', fontSize: 13, color: '#1e293b', borderBottom: '1px solid #f1f5f9' },
  tdAcc:     { padding: '6px 12px', borderBottom: '1px solid #f1f5f9', whiteSpace: 'nowrap' },
  badge:     { padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 500, textTransform: 'capitalize' },
  btnPri:    { padding: '8px 16px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  btnSec:    { padding: '6px 12px', background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1', borderRadius: 6, cursor: 'pointer', fontSize: 13 },
  btnView:   { padding: '4px 10px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 4 },
  btnEdit:   { padding: '4px 10px', background: '#64748b', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 },
  btnDel:    { padding: '4px 10px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 },
  iconBtn:   { background: '#1e293b', border: '1px solid #334155', borderRadius: 6, width: 26, height: 26, cursor: 'pointer', fontSize: 13, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 },
};
